'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$0024156 from "./presto.types$$anon$156.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dEmail$002dPayload$0024 from "./presto.types$-Two-Factor-Auth-Email-Payload$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TwoFactorAuthPayload$$anon$155() {
  this.ccz = null;
  this.ccr = null;
  this.ccs = false;
  this.ccA = null;
  this.ccB = false;
  this.ccE = null;
  this.ccx = null;
  this.ccy = false;
  this.cct = null;
  this.ccu = false;
  this.ccv = null;
  this.ccw = false;
  this.ccC = false;
  this.ccD = false;
  this.ccz = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.ccE = "TwoFactorAuthEmailPayload";
}
export { $c_Lpresto_types$TwoFactorAuthPayload$$anon$155 as $c_Lpresto_types$TwoFactorAuthPayload$$anon$155 };
$p = $c_Lpresto_types$TwoFactorAuthPayload$$anon$155.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuthPayload$$anon$155;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuthPayload$$anon$155() {
}
export { $h_Lpresto_types$TwoFactorAuthPayload$$anon$155 as $h_Lpresto_types$TwoFactorAuthPayload$$anon$155 };
$h_Lpresto_types$TwoFactorAuthPayload$$anon$155.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.ccz;
});
$p.L = (function() {
  if ((!this.ccs)) {
    this.ccr = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.ccs = true;
  }
  return this.ccr;
});
$p.O = (function() {
  if ((!this.ccB)) {
    this.ccA = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.ccB = true;
  }
  return this.ccA;
});
$p.E = (function() {
  return this.ccE;
});
$p.t = (function() {
  if ((!this.ccy)) {
    this.ccx = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.ccy = true;
  }
  return this.ccx;
});
$p.M = (function() {
  if ((!this.ccu)) {
    this.cct = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.ccu = true;
  }
  return this.cct;
});
$p.Q = (function() {
  if ((!this.ccw)) {
    this.ccv = new $j_presto$002etypes$0024$0024anon$0024156.$c_Lpresto_types$$anon$156();
    this.ccw = true;
  }
  return this.ccv;
});
$p.w = (function() {
  if ((!this.ccD)) {
    this.ccC = false;
    this.ccD = true;
  }
  return this.ccC;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee167) => ((p) => \u03b4scrutinee167.cGH(p)))($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dEmail$002dPayload$0024.$m_Lpresto_types$TwoFactorAuthEmailPayload$())));
});
var $d_Lpresto_types$TwoFactorAuthPayload$$anon$155 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuthPayload$$anon$155, "presto.types$TwoFactorAuthPayload$$anon$155", ({
  a2m: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$TwoFactorAuthPayload$$anon$155 as $d_Lpresto_types$TwoFactorAuthPayload$$anon$155 };
//# sourceMappingURL=presto.types$-Two-Factor-Auth-Payload$$anon$155.js.map
